import dayjs from 'dayjs'

export const formatDate = (
  date: string,
  format: string = 'MM/DD/YYYY'
): string => dayjs.utc(date).format(format)
